import { useEffect, useState } from 'react';
import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ActivityLogResponseDto } from '../../../commonTypes/ActivityLogTypes/activityLog.types';
import { ToastStateHandler } from '../../../api';
import { Pageable } from '@cyberlabrs/types';
import { useTranslation } from '../../useTranslation';

interface ActivityLogsParams extends Pageable {}

const SIZE = 10;
const DEFAULT_PAGE = 0;

const useHttpGetActivityLogsOnMountAndExecute = (userSub: string, initialDateFrom?: string, initialDateTo?: string, params?: ActivityLogsParams) => {
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setReady] = useState(false);
    const { t } = useTranslation('newNotifications');
    const [data, setData] = useState<ActivityLogResponseDto | null>(null);
    const [total, setTotal] = useState(0);

    const fetchActivityLogs = (dateFrom?: string, dateTo?: string) => {
        if (!dateTo) dateTo = dateFrom;

        userApi
            .getActivityLogs({
                params: { userSub },
                query: {
                    dateFrom,
                    dateTo,
                    size: params?.size ?? SIZE,
                    page: params?.page ?? DEFAULT_PAGE,
                },
                onSuccess: res => {
                    setTotal(res.body.total);
                    setData(res.body);
                },
                onError: () => toastHandler.push('warn', t('user.activityLogTitle'), t('user.activityLogError')),
                onFinally: () => setReady(true),
            })
            .exec();
    };

    useEffect(() => {
        fetchActivityLogs(initialDateFrom, initialDateTo);
        return () => userApi.getActivityLogs({ params: { userSub } }).abort();
    }, [initialDateFrom, initialDateTo, params?.size]);

    return { data, isReady, total };
};

export default useHttpGetActivityLogsOnMountAndExecute;
